// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pichu: PokeData = {
  "id": 172,
  "name": "pichu",
  "height": 3,
  "weight": 20,
  "base_experience": 41,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "tail-whip",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "thunder",
    "quick-attack",
    "swift",
    "sweet-kiss",
    "charm",
    "spark",
    "iron-tail",
    "nasty-plot",
    "play-nice",
    "nuzzle"
  ],
  "moves": [
    "thunder-shock",
    "thunderbolt",
    "thunder",
    "quick-attack",
    "sweet-kiss",
    "electric-wrath",
    "thunder-fang",
    "wild-charge",
    "thunder-punch",
    "quick-tempo",
    "volt-switch",
    "volt-crash",
    "electric-terrain"
  ],
  "evolution_chain": {
    "id": 10,
    "item": null,
    "species": [
      {
        "name": "pichu",
        "order": 25,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pikachu",
        "order": 26,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 172,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 220,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "raichu",
        "order": 27,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 25,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "thunder-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 22.5,
    "speed": 60,
    "ability_power": 40
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
